import {BrokenEnrollService} from './broken-enroll/broken-enroll.service';

/**
 * Service Dictionary for dynamic loading of CTA Actions which trigger an IAO Chain Service to run.
 */
export const runnableServiceMap = {
  BrokenEnrollService: BrokenEnrollService
};
